import type { ReceiverItem } from '@repo/api-codegen';
import type { AutomationSlackChannel } from '../../api/types/models/automation/automationSlack';

export enum NotificationType {
	EMAIL = 'email',
	SLACK = 'slack',
	ANNOUNCEMENT = 'announcement',
}

export interface NotificationSettings {
	message?: string | null;
	subject?: string | null;
	includeSummary?: boolean;
	channels?: AutomationSlackChannel[] | null;
	recipients?: string[] | null;
	users?: ReceiverItem[] | null;
	user_groups?: ReceiverItem[] | null;
}
